import { type BryntumCalendarProps } from '@bryntum/calendar-react';
import { t } from 'i18next';

import { DEFAULT_CALENDAR_HEIGHT } from './helper';
import { type CalendarProps } from './type';

const getCalendarDefaultProps = ({
  weekStartDay,
  today,
  dayEndTime,
  dayStartTime,
  hideNonWorkingDays,
  mode,
  disableEventEditFeature,
  disableEventCreate,
  height
}: Partial<CalendarProps>): BryntumCalendarProps => ({
  id: `calendar_${Date.now().toString()}`,
  date: today,
  sidebar: false,
  height: `${height ?? DEFAULT_CALENDAR_HEIGHT}px`,
  modes: {
    year: false,
    agenda: {
      emptyText: t('components.views.calendar.loading_events'),
      listRangeMenu: {
        items: {
          listRangeYearItem: null,
          listRangeDecadeItem: null
        }
      },
      eventRenderer(details) {
        const { eventRecord } = details;
        return {
          tag: 'div',
          children: [
            {
              html: eventRecord.name
            }
          ]
        };
      }
    },
    day: {
      dayStartTime,
      dayEndTime,
      eventRenderer(details) {
        const { eventRecord } = details;
        return {
          html: eventRecord.name
        };
      }
    },
    week: {
      dayStartTime,
      dayEndTime,
      eventRenderer(details) {
        const { eventRecord } = details;
        return {
          html: eventRecord.name
        };
      }
    },
    month: {
      autoRowHeight: true,
      maxEventsPerCell: 6,
      eventRenderer(details) {
        const { eventRecord } = details;
        return {
          html: eventRecord.name
        };
      }
    }
  },
  mode,
  weekStartDay,
  hideNonWorkingDays,
  // additional feature for future scope
  eventCopyPasteFeature: {
    disabled: true
  },
  // Disable the default event tooltip when clicking on an event
  eventTooltipFeature: {
    disabled: true
  },
  // Disable the default event editor tooltip when dragging/editing an event
  eventEditFeature: {
    disabled: true
  },
  eventMenuFeature: {
    items: {
      // disabled delete option from calendar view
      deleteEvent: null,
      // additional feature for future scope
      duplicate: null,
      // disable inline edit (right click to show details)
      editEvent: null
    }
  },
  autoCreate: !disableEventCreate,
  dragFeature: {
    creatable: !disableEventCreate,
    draggable: !disableEventEditFeature
  },
  // Disable the context menu
  scheduleMenuFeature: {
    disabled: true
  }
});

export { getCalendarDefaultProps };
